<div>
  <re-captcha class="reCaptcha" #captchaRef="reCaptcha" (resolved)="resolved($event)" *ngIf="isEnabled" [siteKey]="model.siteKey" [size]="model.size"></re-captcha>
</div>